import { DatePickerProps } from 'antd'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isToday from 'dayjs/plugin/isToday'
import isYesterday from 'dayjs/plugin/isYesterday'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { LEGAL_AGE } from 'src/app-constants'

dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isToday)
dayjs.extend(isYesterday)
dayjs.tz.guess()

export const dayStringMonthYearFormat = 'DD MMMM YYYY'
export const dayStringMonthYearHourMinutesFormat = 'D MMMM YYYY • HH:mm'
export const dayMonthYearFormatWithDot = 'DD.MM.YYYY'
export const dayMonthYearHourMinutesFormatWithDot = 'DD.MM.YYYY HH:mm'
export const dayMonthYearHourMinutesFormatSeparator = 'DD/MM/YYYY • HH:mm'
export const yearMonthDaySlash = 'YYYY-MM-DD'
export const yearMonthDayTimeWithT = 'YYYY-MM-DDTHH:mm:ss'
export const dayMonthYearBackSlash = 'DD/MM/YYYY'
export const dayMonthYearHourMinutesFormat = 'DD/MM/YYYY HH:mm'
export const hourMinutesSecondFormat = 'HH:mm:ss'
export const hourMinutesFormat = 'HH:mm'
export const monthNameWithDay = 'MMMM D'

export const today = dayjs()
export const yesterday = dayjs().subtract(1, 'day')

export const formatDate = (date?: string, format?: string) =>
  dayjs(date).format(format ?? dayMonthYearBackSlash)

/**
 * Formats a UTC timestamp for display. When the value has no meaningful time
 * component (midnight UTC = a date-only value), it renders just the date and
 * skips the timezone shift that would otherwise show a bogus "03:00".
 */
export const formatUtcDateTime = (value?: string | null) => {
  if (!value) return '-'

  const utcDate = dayjs.utc(value)

  const isDateOnly =
    utcDate.hour() === 0 && utcDate.minute() === 0 && utcDate.second() === 0

  return isDateOnly
    ? utcDate.format(dayMonthYearFormatWithDot)
    : utcDate.tz().format(dayMonthYearHourMinutesFormatWithDot)
}

export const disableLegalAgeDate: DatePickerProps['disabledDate'] = (current) =>
  current.isAfter(dayjs().subtract(LEGAL_AGE, 'year'))

export const disabledPastDate: DatePickerProps['disabledDate'] = (current) =>
  current.isBefore(dayjs().subtract(1, 'day'))

export const disabledFutureDate: DatePickerProps['disabledDate'] = (current) =>
  current.isAfter(dayjs())

export const legalAgePickerValue = dayjs().subtract(LEGAL_AGE, 'year')

export const getUserAge = (date?: string) => dayjs().diff(dayjs(date), 'year')
